<template>
  <div class="high-importance-notifications">
    <div v-for="notification in notifications" class="notifications">
      <div :class="getStyle(notification) + ' notification'">
        <h3><i :class="getIcon(notification)"></i> {{ notification.title }} <a :href="notification.link" v-if="notification.link">{{ notification.link_title ? notification.link_title : notification.link }}</a></h3>
        <p v-if="notification.message">{{ notification.message }}</p>

      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";

export default {
  data() {
    return {
      notifications: []
    }
  },

  mounted() {
    this.getNotifications();
  },

  methods: {

    getStyle(notification) {

      return notification.type === 'critical' ? 'critical' : 'info';
    },

    getIcon(notification) {
      return notification.type === 'critical' ? 'fa fa-exclamation-triangle icon' : 'fa fa-info-circle icon';
    },

    getNotifications() {
      Axios.get(process.env.VUE_APP_NOTIFICATION_URL + '/high-importance', {headers: {'Authorization': 'Bearer ' + this.$cookies.get('bs_token')}}).then(response => {
        this.notifications = response.data;
        this.notification_loading = false;

        this.notifications.forEach(notification => {
          if (notification.start_date && notification.end_date) {
            notification.duration = [notification.start_date, notification.end_date];
          }
          notification.sticky = notification.sticky ? 1 : 0;
        });
      }, error => {
        //console.log(error);
      });
    }
  }
}

</script>

<style scoped>

.notification {
  padding: 5px;
  text-align: center;
}

.notification h3 {
  font-size: 1.1em;
  padding-top: 5px;
}

.notification p {
  margin: 0;
  padding: 0;
  color: #000;
}

.notification a {
  text-decoration: underline;
  color: #000;
  font-size: 0.8em;
  position: fixed;
  right: 15px;
  margin-top: 5px;
}

.notification .icon {
  position: fixed;
  left: 15px;
  margin-top: 5px;
}


.critical {
  background-color: #ffff99;
  color: #000;
}

.info {
  background-color: yellowgreen;
}

</style>